import apiClient from 'utilities/apiClient';

export const document = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.document}/${url}`, payload, true);
};

export const create_mrn = (url, payload) => {
  return apiClient.patch(`${apiClient.Urls.batch}/${url}`, payload, true);
};
